import router from "../router";

let routerText = "";

let UNIQUE = {
    "职位列表":"",
    "职位详情":"s:1|220",
    "职位列表到职位详情":"s:1|220",
    "职位详情到相似职位":"",
    "成单易列表到职位详情" :"s:1|501",
    "专场列表到职位详情":"",   //s:1|210|专场id
    "公司列表到职位详情":"",  //s:1|252|公司id
    "AI人岗匹配职位列表":"s:1|230",
    "AI人岗匹配列表到职位详情":"s:1|230",
    "AI复推职位列表":"" , //s:1|241|p:订单id@ai@
    "AI复推职位列表到职位详情":"s:1|241", //s:1|241|p:订单id@ai@
    "我的订单":"s:1|241",
    "订单详情":"",
    "我的派单到职位详情":"s:1|801",
    "我的订阅到职位详情":"s:1|226"
} 

let _sendObj = {} , _lastText = ""; //给数据中心的

router.afterEach((to, from) => {
    let fromPath = from.path,
        toPath = to.path,
        toQuery = to.query;
    routerText = "";
    if(fromPath == "/"){ //单独打开 直接刷新的情况下
        // if(toPath == "/aiMatch"){
        //     routerText = "AI人岗匹配";
        // };
        // if(toPath == "/aiMatch" && toQuery.type == "recommend"){
        //     routerText = "AI复推";
        // };
        // if(toPath == "/positions"){
        //     routerText = "职位列表"
        // };
        if(toPath.indexOf('/positions/detail') != -1){
            routerText = "职位详情"
        };

        
        
    };

    if(fromPath == "/positions"){ //从职位列表 打开
        if(toPath.indexOf('/positions/detail') != -1){
            routerText = "职位列表到职位详情"
        };
    };

    if(/\/positions\/detail\/\d+/.test(fromPath)){ //从职位详情打开
        if(toPath.indexOf('/positions/detail') != -1){ //职位详情 -》 职位详情  说明点的是相似职位
            routerText = "职位详情到相似职位"
            UNIQUE[routerText] = "s:1|220" + "|p:" + from.params.positionId + '@ai@';
        };
    };

    if(fromPath == "/cdy"){ //成单易
        if(toPath.indexOf('/positions/detail') != -1){
            routerText = "成单易列表到职位详情"
        };
    };

    if(/\/recruit\/detail\/\d+/.test(fromPath)){ //从专场列表打开
        if(toPath.indexOf('/positions/detail') != -1){
            routerText = "专场列表到职位详情";
            UNIQUE[routerText] = "s:1|210|" + from.params.id; 
        };
    };

    if(/\/employerDetail\/\d+/.test(fromPath)){ //从专场列表打开
        if(toPath.indexOf('/positions/detail') != -1){
            routerText = "公司列表到职位详情";
            UNIQUE[routerText] = "s:1|502|" + from.params.id; 
        };
    };

    if(/\/aiMatch\/matchDetail\/\d+/.test(toPath)){  //从Ai人岗匹配列表打开
        
        routerText = "AI人岗匹配职位列表";
    };

    if(/\/aiMatch\/matchDetail\/\d+/.test(fromPath)){  //从Ai人岗匹配列表打开
        if(toPath.indexOf('/positions/detail') != -1){
            routerText = "AI人岗匹配列表到职位详情";
        };
    };

    if(/\/aiMatch\/recommendDetail\/\d+/.test(toPath)){  //打开复推职位列表
        routerText = "AI复推职位列表";
        UNIQUE[routerText] = "s:1|241"; 
    };

    if(/\/aiMatch\/recommendDetail\/\d+/.test(fromPath)){ //从复推职位列表打开
        if(toPath.indexOf('/positions/detail') != -1){
            routerText = "AI复推职位列表到职位详情";
        };
    };

    
    if(toPath == "/order"){ //我的订单
        routerText = "我的订单"
    };

    if(/\/order\/detail\/\d+/.test(toPath)){  //打开复推职位列表
        routerText = "订单详情";
        UNIQUE[routerText] = "s:1|241|p:" + to.params.sourceId; 
    };


    if(fromPath == "/pa"){ //我的派单到职位详情
        if(toPath.indexOf('/positions/detail') != -1){
            routerText = "我的派单到职位详情"
        };
    };

    if(fromPath == "/subscribe"){ //我的订阅到职位详情
        if(toPath.indexOf('/positions/detail') != -1){
            routerText = "我的订阅到职位详情"
        };
    };

    // 把上一次清空
    if(_sendObj[_lastText]){
        _sendObj[_lastText] = false;
    };

    if(routerText){
        _lastText = routerText;
    };

})




let statistics = (config , curPath) => {
    let { path , query , name } = curPath;
    let { url , params} = config;
    
    params = params? params : {};
    
    if(UNIQUE[routerText]){
        params.queryUnique = UNIQUE[routerText];
        if(/\d+\/aiMatch$/.test(url) || /listHomologous\/position/.test(url)){ //aiMatch
            
            let t = UNIQUE[routerText].split(/(\|t:|\|p:)/)[0]; //防止相似职位点相似职位继续往后带的问题
            if(params.type == 3){ //人岗匹配 详情直接打开
                params.queryUnique = t + '|t:'+ params.id +'@ai_tlt@';
            };
            if(params.type == 0  || /listHomologous\/position/.test(url) ){ //相似职位 详情直接打开
                params.queryUnique = t + '|p:'+ (params.id || params.positionId) +'@ai@';
            };
            if(routerText == "AI人岗匹配职位列表"){
                params.queryUnique = t + '|t:'+ params.id +'@ai_tlt@';
            };
            if(routerText == "AI复推职位列表"){
                params.queryUnique = t + '|p:'+ params.id  +'@ai@';
            };
        };

        if(ho_track.position_track && !_sendObj[_lastText] && (params.id || params.positionId)){
            ho_track.position_track((params.id || params.positionId),params.queryUnique , UNIQUE[routerText] , url);
            _sendObj[_lastText] = true;
        };
        

    };
    
    return config;
};



export default statistics